/**
 * Utilities for parsing and formatting file upload error messages.
 *
 * Most processing errors are already curated by the backend (get_upload_error_detail).
 * This function only rewrites raw HTTP-level errors (413 file size, 415 unsupported type)
 * that come from FastAPI validators before our error handler runs.
 */
export function parseFileUploadError(errorMessage: string): string {
  // Handle unsupported file type errors (415 from validators)
  if (errorMessage.toLowerCase().includes('unsupported file type')) {
    const typeMatch = errorMessage.match(/unsupported file type[:\s]+([^.]+)/i);
    if (typeMatch) {
      const fileType = typeMatch[1].trim();
      if (fileType && fileType !== 'unknown') {
        return `File type "${fileType}" is not supported. Please upload a supported file format.`;
      }
    }
    return 'This file type is not supported. Please upload a supported file format.';
  }

  // Handle file size errors (413 from validators)
  const sizeMatch = errorMessage.match(/maximum allowed size \(([\d.]+) MB\)/i);
  if (sizeMatch) {
    const maxSize = sizeMatch[1];
    return `File is too large. Maximum file size is ${maxSize} MB.`;
  }

  if (errorMessage.toLowerCase().includes('exceeds maximum')) {
    return 'File is too large. Please upload a smaller file.';
  }

  // Trust backend-curated messages as-is
  return errorMessage;
}
